import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faPlay } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import HeroImage from '../../assets/itech.jpg';
import data from './data';
import './header.css';

const Header = () => {
  const handleConsultationClick = () => {
    const whatsappUrl = 'https://api.whatsapp.com/send?phone=62895339559888&text=Halo%20iTech%20Service!%20Saya%20ingin%20konsultasi%20gratis%20untuk%20perangkat%20Apple%20saya.';
    window.open(whatsappUrl, '_blank');
  };

  const handleLearnMoreClick = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="hero" id="header">
      <div className="hero__background">
        <div className="hero__gradient"></div>
      </div>
      
      <div className="container">
        <div className="hero__container">
          {/* Hero Content */}
          <div className="hero__content">
            <div className="hero__badge" data-aos="fade-up">
              <FontAwesomeIcon icon={faRocket} className="hero__badge-icon" />
              <span>Layanan Reparasi Apple Terpercaya</span>
            </div>
            
            <h1 className="hero__title" data-aos="fade-up" data-aos-delay="100">
              Layanan Reparasi Perangkat
              <span className="hero__title-highlight"> Apple Profesional</span>
            </h1>
            
            <p className="hero__subtitle" data-aos="fade-up" data-aos-delay="200">
            Layanan profesional untuk iPhone, iPad, MacBook, dan perangkat Apple lainnya dengan penanganan teknisi berpengalaman, suku cadang berkualitas, dan garansi servis terpercaya.
            </p>

            <div className="hero__stats" data-aos="fade-up" data-aos-delay="300">
              <div className="hero__stat">
                <span className="hero__stat-number">1000+</span>
                <span className="hero__stat-label">Perangkat Diperbaiki</span>
              </div>
              <div className="hero__stat">
                <span className="hero__stat-number">24/7</span>
                <span className="hero__stat-label">Dukungan Tersedia</span>
              </div>
              <div className="hero__stat">
                <span className="hero__stat-number">99%</span>
                <span className="hero__stat-label">Tingkat Keberhasilan</span>
              </div>
            </div>

            <div className="hero__actions" data-aos="fade-up" data-aos-delay="400">
              <button 
                className="btn btn-primary hero__cta"
                onClick={handleConsultationClick}
                aria-label="Dapatkan konsultasi gratis via WhatsApp"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
                <span>Konsultasi Gratis</span>
              </button>
              
              <button 
                className="btn btn-secondary hero__learn-more"
                onClick={handleLearnMoreClick}
                aria-label="Pelajari lebih lanjut tentang layanan kami"
              >
                <FontAwesomeIcon icon={faPlay} />
                <span>Jelajahi Layanan</span>
              </button>
            </div>

            {/* Social Links */}
            <div className="hero__social" data-aos="fade-up" data-aos-delay="500">
              <span className="hero__social-text">Ikuti kami:</span>
              <div className="hero__social-links">
                {data.map((item) => (
                  <a 
                    key={item.id} 
                    href={item.link} 
                    className="hero__social-link"
                    target="_blank" 
                    rel="noopener noreferrer"
                    aria-label={`Ikuti kami di ${item.title || 'media sosial'}`}
                  >
                    {item.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="hero__image-container">
            <div className="hero__image" data-aos="fade-left" data-aos-delay="300">
              <img 
                src={HeroImage} 
                alt="Layanan reparasi perangkat Apple profesional" 
                className="hero__image-main"
                loading="eager"
              />
              <div className="hero__image-overlay">
                <div className="hero__image-badge">
                  <FontAwesomeIcon icon={faRocket} />
                  <span>Layanan Ahli</span>
                </div>
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="hero__floating-elements">
              <div className="hero__floating-element hero__floating-element--1" data-aos="fade-up" data-aos-delay="600">
                <div className="hero__floating-icon">
                  <FontAwesomeIcon icon={faRocket} />
                </div>
                <div className="hero__floating-text">
                  <span className="hero__floating-title">Reparasi Cepat</span>
                  <span className="hero__floating-desc">Layanan di hari yang sama</span>
                </div>
              </div>
              
              <div className="hero__floating-element hero__floating-element--2" data-aos="fade-up" data-aos-delay="700">
                <div className="hero__floating-icon">
                  <FontAwesomeIcon icon={faRocket} />
                </div>
                <div className="hero__floating-text">
                  <span className="hero__floating-title">Suku Cadang Asli</span>
                  <span className="hero__floating-desc">Kualitas terjamin</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
